import React from "react";
import clsx from "clsx";

export default function MasterCard({ children, className = "", padding = true }) {
	return (
		<div
			className={clsx(
				"card rounded-xl border shadow-tailwick-panel w-full",
				"bg-card border-default-200",
				"dark:bg-default-900 dark:border-default-700",
				padding && "p-4 sm:p-6",
				className
			)}
		>
			{children}
		</div>
	);
}
